/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetSeoUrlsFromQueryStringsResponseSchema } from '../../entities/schemas/GetSeoUrlsFromQueryStringsResponseSchema';

export type TGetSeoUrlsFromQueryStringsModel = IModel<
  IGetSeoUrlsFromQueryStringsRequest,
  TGetSeoUrlsFromQueryStringsResponse
>;

export interface IGetSeoUrlsFromQueryStringsRequest {
  /** Список query strings **/
  queryStrings: string[];
  /** Тип seo url **/
  urlType: EUrlType;
}

export type TGetSeoUrlsFromQueryStringsResponse =
  | IGetSeoUrlsFromQueryStringsResponse200
  | IGetSeoUrlsFromQueryStringsResponse400;

export interface IGetSeoUrlsFromQueryStringsResponse200 extends IModelResponse<IGetSeoUrlsFromQueryStringsResponse> {
  statusCode: 200;
}

export interface IGetSeoUrlsFromQueryStringsResponse400
  extends IModelResponse<IGetSeoUrlsFromQueryStringsResponseError> {
  statusCode: 400;
}

export interface IGetSeoUrlsFromQueryStringsResponse {
  data: IGetSeoUrlsFromQueryStringsResponseSchema;
  status: EStatus;
}

export interface IGetSeoUrlsFromQueryStringsResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetSeoUrlsFromQueryStringsResponse | IGetSeoUrlsFromQueryStringsResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export enum EUrlType {
  /** Агенты **/
  Agents = 'agents',
  /** ТЦ/БЦ **/
  BsCenters = 'bsCenters',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Новостройки **/
  Newobjects = 'newobjects',
  /** Объявления **/
  Offers = 'offers',
  /** КП **/
  Villages = 'villages',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetSeoUrlsFromQueryStringsResponse): TResponse200;
  400(response: IGetSeoUrlsFromQueryStringsResponseError): TResponse400;
}
